var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['progress-bar'],attrs:{"aria-hidden":"true"}},[_c('div',{class:_vm.$style['progress-bar__fill'],style:(_vm.fillStyle),on:{"animationend":function($event){return _vm.$emit('end')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }